import '../../App.css';
import React, {Component, Container} from 'react';
import {Image,Navbar, Nav, NavItem, NavDropdown} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import YoutubeBackground from 'react-youtube-background';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import NavBarTop from "./navbar";
import Footer from "./footer";
const applyurl = "https://docs.google.com/forms/d/e/1FAIpQLScoSIrXM_CqsXcaw6mSZmB8f6E1MoXcis3QFeRaE_SO6cP_5A/viewform?usp=sf_link"

class IESADJury extends Component {
  constructor(props){
    super(props);
    this.state = {  
       
    };

    this.setval = this.setval.bind(this)
  }
  componentDidMount(){
    document.title="Worldwide Dance Arts Competition"
    var link1 = document.getElementById('favicon')
    var link2 = document.getElementById('touchicon')
    link1.href="/assets/wdac-logo.PNG"
    link2.href="/assets/wdac-logo.PNG"
    this.props.setval({comp:"iesad"})  
  }
  setval(obj){
    this.setState(obj)
  }

  render(){
    return (
      <div>
       {/* <img src="/assets/term.png" width="100%" style={{borderRadius:"0px"}} /> */}
      <div style={{display:"flex",flexDirection:"column",paddingLeft:"15%",paddingRight:"15%",paddingTop:"3%",paddingBottom:"2%",textAlign:"left"}}>
      <h4 style={{fontSize:"1.8em",textAlign:"center",marginBottom:"100px"}}>Principal Adjudicator</h4>

      <div style={{display:'block', marginBottom:"100px"}}>
        <div className="jury-text" style={{marginLeft:"0px",marginRight:"4%"}}>
            <p> 
            Professor Slobodchikova had joined many Dance Festivals as a
            member jury or as an expert such as the Tanzmesse
            (Dusseldorf), Impulstanz (Vienna), Spring
            Board (France), ADF (USA), Czech dance
            platform, Holland dance festival and European
            project with Anouk van Dijk and many others
            in Russia and Belorussia.
            </p>
            <p>
              In 1998, Prof. Slobodchikova founded the Center of contemporary
            dance in Russia, and leading it as an Artist
            Director. Having Choreographed numerous original works for
            her own dance company and for theatres
            across Russia (Krasnoyarsk, Novosibirsk,
            Vladivostok, Moscow and others), she have also
            directed Dance Company`s participation in
            International festivals across the USA, China
            and Germany. She, as well, facilitated collaboration with world-renowned
            choreographers including Olga Pona, Nejla
            Yatkin, Daria Buzovkina, Lindsy Dietz
            Marchant and Jason Dietz Marchant, Janis
            Brenner, Istok Kovach and others.</p>

            <p>
            Invited to conduct master-classes
            and workshops in Russia, Belorussia, China,
            USA, Latvia, Hong Kong, South Korea, Spain,
            Germany and other countries, Prof. Slobodchikova have received grants and 
            Institutional support from Ford Foundation, Trust of Mutual Understanding,
            Prohorov Foundation, Goether Institute.
           </p>
           
        </div>

        <div className="jury-profile" style={{position:"relative"}}>
        <div style={{position:"absolute"}}>
            {/* <img className="jury-flag" alt="" src="/assets/uk-flag.png"/> */}
            </div>
            <img src="/assets/elena-profile.png" alt=""  width="100%"/>
            <h4 style={{marginTop:"5px"}}><b>Elena Slobodchikova</b></h4>
            <h5><em>Professor of Moscow State Institute of Culture, Dance department</em></h5>
            </div>
        
        

    </div>


    
    {/* <div style={{display:'block', marginBottom:"100px"}}>
        <div className="jury-profile">
            <img src="/assets/alexandre.jpg" alt=""  width="100%"/>
            <h4 style={{marginTop:"5px"}}><b>Mr. Alexandre Teheux</b></h4>
            <h5><em>Pianist and Music Educationist</em></h5>
            </div>
        <div style={{position:"absolute"}}>
            <img className="jury-flag" alt="" src="/assets/belgium-flag.jpg" /></div>
        <div className="jury-text"><p>
            Born in Paris in 1959, Alexandre Teheux studied under Frederic Delvaux, and began his musical studies at Academie Gretry in Liege with Jeanne Bernard-Knapen.
            He then studied in Liege Conservatory with Chantal Bohets and Marcelle Mercenier. He later received a grant from Belgian government which 
            led him to travel and study at Chopin Academy in Warsaw.</p><p>
             With more than 20 years of teaching experience, Alexandre teaches regulary at Academie Gretry, as well as performing in concerts, notably with the violinist Benoit Paquay.
        </p></div>
    </div> */}

      </div>
      </div>
    );
  }
  }
  

export default IESADJury;
